import { useAnimationContext } from '../../../context/useAnimationContext';
import { useTimer } from '../useTimer';

export const useShouldShowGameInfoLoader = () => {
    // This is an entrie point of animation on open
    const isTimerExceed = useTimer(800);
    const { shouldAnimateOnOpen } = useAnimationContext();

    return !isTimerExceed && shouldAnimateOnOpen;
};
